module.exports = __webpack_public_path__ + "img/octagon-minus.4ec4aeff.svg";